import { IExportPlugin, LayerType, PluginType } from '@/version-types';
import qrCodeLayerBehavior from './behavior';
import { QRCodeLayer } from './controller';

export { QRCodeLayer } from './controller';
export * from './utils';

/**
 * 二维码图层插件
 */
export const qrCodeLayerPlugin: IExportPlugin = {
    sort: 0,
    type: PluginType.LAYER,
    name: LayerType.QR_CODE,
    createInstance({ identity }) {
        return [{ key: 'QRCodeLayer', value: new QRCodeLayer(identity) }];
    },
    createBehavior() {
        return qrCodeLayerBehavior;
    },
};
